import clsx from 'clsx';
import React from 'react';
import { useParams } from 'react-router';

import LongTextByWidth from '@/src/components/common/Elements/LongText/LongTextByWidth';
import TagsManager from '@/src/components/project/Tags/TagsManager';

import { useUpdateFileStatus } from '../../../../components/EntryPanel/FileEntryViewer/api/updateFileStatus';
import UpdateFileStatus from '../../../../components/EntryPanel/FileEntryViewer/components/UpdateFileStatus/UpdateFileStatus';
import { getFileEntryToUpdateStatus } from '../../../../models/FileEntry';
import { FileEntry } from '../../../../types';
import AccountLink from '../../../components/AccountLink/AccountLink';
import { useFileDetails } from '../../../../components/EntryPanel/FileEntryViewer/api/getFileDetails';

type HeaderProps = {
  fileEntry: FileEntry;
  projectName: string;
};

const Header = ({ fileEntry, projectName }: HeaderProps) => {
  const { projectId } = useParams<{ projectId: string; inboxEntryId: string }>();
  const updateStatusMutation = useUpdateFileStatus({
    fileId: fileEntry.id,
    projectId,
  });

  const fileDetails = useFileDetails({ fileId: Number(fileEntry.id) });

  const fileTags = fileDetails.data?.data?.tags ?? [];

  return (
    <div
      className={clsx(
        'tw-flex tw-items-center tw-justify-between',
        'tw-shadow-none',
        'tw-min-h-[52px]',
        'tw-border-b-[1px] tw-border-b-solid tw-border-b-cfo-grey-500',
        'tw-py-[9px] tw-px-[10px] tw-mb-0'
      )}
      style={{ position: 'relative' }}
    >
      <div className="tw-flex">
        <LongTextByWidth
          className={clsx(
            'tw-flex tw-items-center',
            'tw-text-cfo-black tw-leading-normal tw-font-brandonTextMedium'
          )}
          tooltipClassName="!tw-max-w-[500px] !tw-w-auto tw-text-center tw-whitespace-normal tw-break-words"
          id={`document_subject`}
          maxLines={1}
          maxWidth={250}
          value={fileEntry.file.name}
        />
        <AccountLink projectName={projectName} projectId={projectId} />
      </div>
      <div
        className={'tw-flex tw-items-center tw-relative'}
        style={{ position: 'relative', minWidth: 200, maxWidth: 200 }}
      >
        <TagsManager
          rowId={String(fileEntry.file.id)}
          isFilesTable={false}
          inboxDocumentId={fileEntry.id}
          projectId={projectId}
          assignedTags={fileTags ?? []}
          style={{ position: 'absolute' }}
        />
      </div>
      <div className={'tw-flex tw-items-center'}>
        <UpdateFileStatus
          fileEntry={getFileEntryToUpdateStatus(fileEntry)}
          updateStatusMutation={updateStatusMutation}
        />
      </div>
    </div>
  );
};

export default Header;
